import useGetCurrentCommunity from './useGetCurrentCommunity';
import usePlanHook from './usePlanHook';
import { FeatureIdentifiers, PlanDetail } from '../store/types';

type UseRecommendedPlanByVerifiedMembersReturn = {
  recommendedPlanName: string;
  recommendedPlan?: PlanDetail;
};

export default function useRecommendedPlanByVerifiedMembers(
  platform: string,
  currentVerified: number,
): UseRecommendedPlanByVerifiedMembersReturn {
  const communityCheck = useGetCurrentCommunity();
  const { plans } = usePlanHook(communityCheck);

  const planPrefix = platform === 'telegram' ? 'TEL#BOT#PLAN' : 'BOT#PLAN';
  const platformPrefix = platform === 'discord' ? 'DIS' : 'TEL';

  function getPlanMaxVerified(plan: PlanDetail): number {
    const feature = plan.features?.find(
      (f) => f.identifier === FeatureIdentifiers.MAX_VERIFIED_MEMBERS,
    );
    const value = feature?.metadata;
    return typeof value === 'number' ? value : Number.MAX_SAFE_INTEGER;
  }

  const relevantPlans = (plans || [])
    .filter((p) => !p.hide && p.pk.startsWith(planPrefix))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  if (relevantPlans.length === 0) {
    return {
      recommendedPlanName: platformPrefix === 'DIS' ? 'Exclusive' : 'Premium',
    };
  }

  const matched = relevantPlans.find(
    (p) => getPlanMaxVerified(p) > currentVerified,
  );
  const chosen = matched ?? relevantPlans[relevantPlans.length - 1];

  return { recommendedPlanName: chosen.name, recommendedPlan: chosen };
}
